import React from 'react';
import { AdvanceDecisonType } from '../../../utils';

interface AdrtLocationProps {
  advanceDecision: AdvanceDecisonType;
  setAdvanceDecision: React.Dispatch<React.SetStateAction<AdvanceDecisonType>>;
}
const AdrtLocation: React.FC<AdrtLocationProps> = ({
  advanceDecision,
  setAdvanceDecision,
}) => {
  return (
    <div className="govuk-form-group">
      <h1 className="govuk-label-wrapper">
        <label className="govuk-label govuk-label--l" htmlFor="adrt-location">
          The Location of the ADRT document
        </label>
      </h1>
      <textarea
        className="govuk-textarea"
        id="adrt-location"
        name="AdrtLocation"
        rows={5}
        aria-describedby="adrt-location"
        placeholder="The location of the ADRT"
        value={advanceDecision.location}
        onChange={e => {
          setAdvanceDecision(prev => ({
            ...prev,
            location: e.target.value,
          }));
        }}
      />
    </div>
  );
};

export default AdrtLocation;
